module.exports = __webpack_public_path__ + "static/logo-e924b176da5ae0188ad1af995b900628.png";